/**
 * @desc 列表
 */
const URL = "/rantion-crawler";
import http, { updateResponse } from "@/http";
export function request(body: defs.crawler.CrawlerTaskRequestParamsDto, options?: any) {
  return updateResponse(
    http(URL + `/crawlerTask/list`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
